import { IModelEntity } from '@pit/core';
import { IDtoShipmentProcessRecipient } from './dto.shipment.process.recipient.interface';
import { IDtoShipmentReturnCode } from './dto.shipment.return.code.interface';

export enum ShipmentDeliveryType {

    None = 1,
    LetterBox = 2,
    ThirdParty = 4,
    Recipient = 8,
    DepositToDepot = 16

}

export enum ShipmentProcessState {

    Unknown = 0,
    InDepot = 1,
    AssignedToPostman = 2,
    InDelivery = 4,
    DeleteFromDevice = 8,
    Returned = 16,
    Completed = 32,
    HandedOverToRecipient = 64,
    FinishedWorkDay = 128,
    ReturnedToDepot = 256,
    Lost = 512

}

export enum ProductionSystemTransferState {

    NotTransferred = 1,
    TransferError = 2,
    Transferred = 4,
    Internal = 8,
    ReserveForArchive = 16,
    Archived = 32

}


export interface IDtoShipmentProcess extends IModelEntity {

    externalShipmentId?: string;
    shipmentId?: number;
    timestamp?: Date;
    userName?: string;

    deliveryType?: ShipmentDeliveryType;
    processState?: ShipmentProcessState;
    isSyncedToServer?: boolean;
    latitude?: number;
    longitude?: number;
    shipmentPhoto?: string;
    productionSystemTransferState?: ProductionSystemTransferState;
    productionSystemTransferPlannedTime?: Date;

    recipient?: IDtoShipmentProcessRecipient;
    returnCode?: IDtoShipmentReturnCode;

    deliveryFullAddress?: string;
    deliveryFullDescription?: string;
    isFinished?: boolean;
    isOpen?: boolean;
    processStateDescription?: string;

}
